export const targetsKeys = {
  all: ["targets"] as const,
  list: () => [...targetsKeys.all, "list"] as const,
};
